import { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './contact.scss';

const Contact = () => {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [status, setStatus] = useState('');
    const [statusView, setStatusView] = useState(false);
    const [verif, setVerif] = useState(false);

    const handleChange = (e) => {
        if (verif === false) {
            setVerif(true);
        }
        else {
            setVerif(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatusView(true);
        setStatus('Envoi en cours...');

        try {
            // Remplace par l'URL publique de ton serveur API
            const response = await fetch('https://contact.guillaume-sanchez.fr/send', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                setStatus('Message envoyé ! Merci.');
                setFormData({ name: '', email: '', message: '' });
            } else {
                setStatus(`Erreur : ${result.error || 'Problème serveur.'}`);
            }
        } catch (error) {
            setStatus('Impossible de joindre le serveur.');
        }
    };
    return (
        <main className="contact">
            <h2 className="contact-title">Contact</h2>
            <p className="contact-description">Recruteur intéressé ? 👨‍💻</p>
            <p className="contact-description">Une idée ou un projet à me proposer ? 💡</p>
            <p className="contact-description">Remplissez ce formulaire ! ✍️</p>
            <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-input">
                    <div className="contact-input-div">
                        <label>Votre Nom</label>
                        <input className="contact-input-content" type="text" name="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                    </div>
                    <div className="contact-input-div">
                        <label>Votre Email</label>
                        <input className="contact-input-content" type="email" name="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                    </div>
                </div>
                <div className="contact-input-message">
                    <label>Votre Message</label>
                    <textarea className="contact-input-content" name="message" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
                </div>
                <ReCAPTCHA
                    className="ReCAPTCHA"
                    sitekey="6Let7vEUAAAAAEyvmRWIQ-j8FN8jszkaXToHR2UB"
                    onChange={handleChange}
                >
                    {verif
                        && (
                            <input className="contact-send-input" type="submit" value="Envoyer" />
                        )}
                </ReCAPTCHA>
                {statusView
                    && (
                        <p className="contact-send">{status}</p>
                    )}
            </form>
        </main>
    );
};

export default Contact;